<template>
  <div class="ranking-item">
    <div class="ranking-position">
      <span>{{ item.rank || '--' }}</span>
    </div>
    <div class="ranking-info">
      <div class="user-info">
        <div class="user-avatar">{{ name }}</div>
        <p class="user-name">
          {{ item.dd_student_name || item.real_name }}
        </p>
      </div>
      <div class="end-time">
        {{ setFormatDateTime(item.end_time) }}
      </div>
    </div>
  </div>
</template>

<script>

import { formatDateTime } from '@/utils';

export default {
  name: 'PassListItem',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    name() {
      const name = this.item.dd_student_name || this.item.real_name;
      return name && name.slice(-2);
    },
  },
  methods: {
    setFormatDateTime(time) {
      return formatDateTime(time);
    },
  },
};
</script>

<style lang="scss" scoped>
.ranking-item {
  display: flex;
  align-items: center;
  height: 128px;
  color: #111f2c;

  .ranking-position {
    width: 112px;
    font-size: 32px;
    text-align: center;
  }
  .ranking-info {
    flex: 1;
    box-sizing: border-box;
    height: 128px;
    border-bottom: 2px solid rgba(17, 31, 44, 0.12);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .user-avatar {
    border-radius: 50%;
    width: 72px;
    height: 72px;
    background-color: #3295f8;
    margin-right: 24px;
    text-align: center;
    line-height: 72px;
    color: #fff;
    font-size: 24px;
  }
  .user-info {
    display: flex;
    align-items: center;
    flex: 1;
  }
  .user-name {
    font-size: 34px;
    width: 150px;
  }
  .end-time {
    padding-right: 32px;
    text-align: right;
    color: #111f2c;
    opacity: 0.56;
    font-size: 28px;
    flex: 1;
  }
  .star-info {
    font-size: 28px;
    padding-right: 24px;
    color: #ff9f00;
    width: 110px;
    text-align: right;

    .icon-star {
      font-size: 32px;
      padding-left: 8px;
    }
  }
  .ranking-top {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 56px 48px;
    width: 100%;
    height: 48px;
  }
  .rank-01 {
    // background-image: url('~@/views/summer/images/first.png');
  }
  .rank-02 {
    // background-image: url('~@/views/summer/images/second.png');
  }
  .rank-03 {
    // background-image: url('~@/views/summer/images/third.png');
  }
  .ranking-badge {
    display: inline-block;
    margin-left: 1em;
    line-height: 40px;
    background: rgba(95, 211, 189, 1);
    border-radius: 8px;
    padding: 0 12px;
    color: #fff;
    font-size: 24px;
  }
  .icon-right {
    color: #111f2c;
    opacity: 0.4;
    padding-right: 32px;
  }
}
</style>
